import { useCallback, useEffect, useRef } from 'react';
import { useWizard } from 'react-use-wizard';

import { useSession, useIsSessionComplete } from '@/features/guided-financial-planning/context';
import { useGuidedPlanningQuotes } from '@/features/guided-financial-planning/hooks';
import { QuoteLoadingSequence } from '@/features/guided-financial-planning/components/quote-loading-sequence';

export function QuotesLoadingStep() {
  const { nextStep } = useWizard();
  const { session } = useSession();
  const isSessionComplete = useIsSessionComplete();
  const clientId = session?.clientId ?? '';
  const hasAutoAdvanced = useRef(false);

  const { isLoading, isFetched } = useGuidedPlanningQuotes(clientId, session);

  const isDataLoaded = !isLoading && isFetched;

  // Skip loading animation for completed sessions
  useEffect(() => {
    if (isSessionComplete && !hasAutoAdvanced.current) {
      hasAutoAdvanced.current = true;
      nextStep();
    }
  }, [isSessionComplete, nextStep]);

  const handleComplete = useCallback(() => {
    if (!hasAutoAdvanced.current) {
      hasAutoAdvanced.current = true;
      nextStep();
    }
  }, [nextStep]);

  // Don't render loading animation for completed sessions
  if (isSessionComplete) {
    return null;
  }

  return <QuoteLoadingSequence isDataLoaded={isDataLoaded} onComplete={handleComplete} />;
}
